import { render, staticRenderFns } from "./Ttns.vue?vue&type=template&id=4c044f00&"
import script from "./Ttns.vue?vue&type=script&lang=js&"
export * from "./Ttns.vue?vue&type=script&lang=js&"
import style0 from "./Ttns.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports